/**
 * Emit a tag to Facebook
 *
 * @param {String} tag Event label to send to Facebook
 */
function track(...params) {
    if (typeof window.fbq !== 'function') {
        return;
    }
    window.fbq(...params);
}

/**
 * FacebookService tracking Service.
 */
export default class FacebookService {
    /**
     * Track Signup (first Estima)
     */
    static trackSignupSuccess() {
        track('track', 'Lead');
        track('trackCustom', 'Lead_First_Estima');
    }

    /**
     * Track all Estimas success
     */
    static trackEstimaSuccess() {
        track('track', 'Lead');
        track('trackCustom', 'All_Estima_Result');
    }
}
